import { connect } from 'react-redux'
import { ServiceViewPassengerType } from '../../components/services/view/ServiceViewPassengerType'
import { IStoreState, IRiderFilters, IServicePricingTypeObject } from '../../types/index'
import { getMany } from '../../state/actions/riders'
import { getRidersList } from '../../state/reducers/riders'
import { actions } from 'react-table'
import * as serviceActions from '../../state/actions/services'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  return {
    steps: state.serviceEdit.steps.list,
    routeProps: ownProps.routeProps,
    serviceId: ownProps.serviceId,
    orgId: state.organizations ? state.organizations.currentOrgId : '',
    pricingType: state.service.pricingType,
    fares: state.service.fares
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getMembers: (filters: IRiderFilters) => {
      return dispatch(getMany(filters))
    },
    //PricingType
    fetchServicePricingType: (serviceId: string) => dispatch(serviceActions.fetchServicePricingType(serviceId))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceViewPassengerType)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceViewPassengerType.ts